function toggler() {
    const icon = document.querySelector("#toggler");
    const nav = document.querySelector(".nav");
    const nav_child = document.getElementsByTagName("li")

    if(icon.classList.contains("fa-bars")) {
        icon.classList.replace("fa-bars", "fa-window-close");
        nav.style.display = "flex";
         for (let i = 0; i < nav_child.length; i++) {
          if(nav_child[i].classList.contains("menu-item-has-children")) {
            nav_child[i].classList.remove("menu-item-has-children");
            nav_child[i].classList.add("menu-item-home"); 
            nav_child[i].classList.add("navc"); 
          }
         }
     } else {
      icon.classList.replace("fa-window-close", "fa-bars");
        nav.style.display = "none";
        for (let i = 0; i < nav_child.length; i++) {
          if(nav_child[i].classList.contains("navc")) {
            nav_child[i].classList.remove("menu-item-home"); 
            nav_child[i].classList.remove("navc"); 
            nav_child[i].classList.add("menu-item-has-children");
          }
         }
    }

}